import React from 'react';
import cx from 'classnames';
import './style.scss';

interface CheckboxProps {
  id?: string;
  className?: string;
  name: string;
  label?: React.ReactElement | string;
  checked: boolean;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  onChange: (e: any) => void;
}

const Checkbox = ({ className, name, label, checked, required, readOnly, disabled, ...props }: CheckboxProps) => {
  const onChange = (e: any) => {
    props.onChange({
      target: {
        name,
        value: e.target.checked,
      },
    });
  };

  return (
    <label className={cx('checkbox', className, disabled && 'disabled')}>
      <input
        name={name}
        type="checkbox"
        checked={checked}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
        onChange={onChange}
      />
      {label}
    </label>
  );
};

export default Checkbox;
